import React from 'react';
import { Navigate } from 'react-router-dom';
import { useUser } from '../userContext';
import DefaultLoading from '../common/DefaultLoading';

const AdminRoute = ({ children }) => {
  const { user, userProfile, loading } = useUser();

  if (loading) {
    return <DefaultLoading context="authentication" />;
  }

  if (!user) {
    return <Navigate to="/studio/login" replace />;
  }

  // Check if user is admin
  const isLocalhost = window.location.hostname === 'localhost' || window.location.hostname === '127.0.0.1';
  const isDevSite = window.location.hostname === 'smilesflowdev-1514f.web.app';
  const isProduction = window.location.hostname === 'groupchatheroes.com';
  
  // Allow any logged-in user on localhost and dev site, but only rob@groupchatheroes.com on production
  const isAdmin = isLocalhost || isDevSite || 
    (isProduction && (userProfile?.email === 'rob@groupchatheroes.com' || user?.email === 'rob@groupchatheroes.com'));

  if (!isAdmin) {
    return <Navigate to="/studio/dashboard" replace />;
  }

  return children;
};

export default AdminRoute; 